<template>
    <div class="form-group--border">
        <div class="scrollable-content">
            <div class="pmpk-view">
                <div v-if="!haveCurrent">
                    <h4 class="text-gray text-center">нет действующих ИМАРов</h4>
                </div>
                <template v-if="items && items.length > 0">
                        <div v-for="(items, key) in itemsFilter" :key="key" class="row" :class="{'text-gray': /*!haveCurrent*/ !items.some(x => x.dateEnd >= now)}">
                            <div class="form-group  d-flex flex-wrap align-items-center solid justify-content-between mt-3">
                                <h4 class="m-0">{{key}}</h4>                                     
                            </div>
                            <div>
                                <dropdown v-for="item in items" :key="item.id">
                                    <template v-slot:title>
                                        <span :class="{'text-red': item.actionRefuse}">{{item.serviceTypeName}}</span>
                                    </template>
                                    <template v-slot:text>
                                        {{ $momentFormat(item.dateBegin, "DD.MM.YYYY") }} - <span :class="{'text-red': item.dateEnd < now}">{{ $momentFormat(item.dateEnd, "DD.MM.YYYY") }}</span>
                                    </template>
                                    <template v-slot:actions>
                                        <div>
                                          <i class="fas fa-eye mx-2" @click.stop="viewCard(item.id)" title="Просмотр"></i>
                                        </div>
                                    </template>
                                    <template v-slot:default>
                                    <div>
                                        
                                        <h4 class="mb-4">Общая информация</h4>
                                        <div class="table-inner mb-4">
                                            <table class="table-custom">
                                                <thead>
                                                <tr>
                                                    <th  class="col1" >Услуга</th>
                                                    <th width="80px" class="col2">Объем</th>
                                                    <th width="100px" class="col3">Периодичность</th>
                                                    <th width="240px" class="col4">Срок предоставления услуги</th>
                                                    <th width="100px" class="col5">Отметка о выполнении</th>
                                                    <th width="100px" class="col5">Расписание</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td class="col1" >{{ item.serviceTypeName }}</td>
                                                    <td class="col2">{{ item.count }}</td>
                                                    <td class="col3">{{ item.period }}</td>
                                                    <td class="col4">{{ $momentFormat(item.dateBegin, "DD.MM.YYYY") }} - {{
                                                            $momentFormat(item.dateEnd, "DD.MM.YYYY")
                                                        }}
                                                    </td>
                                                    <td class="col5">
                                                        <Checkbox :id="'isCompleted_' + item.id" v-bind:modelValue="item.isCompleted" class="text-center" :disabled="true"/>
                                                    </td>
                                                    <td class="col5">{{ item.schedule }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <template v-if="item.actionRefuse">
                                            <h4>Отказ от услуги</h4>
                                            <div class="table-inner mb-4">
                                            <table class="table-custom">
                                                <thead>
                                                <tr>
                                                    <th>Отметка об отказе</th>
                                                    <th>Причина отказа</th>
                                                    <th>Инициатор отказа</th>
                                                    <th>Дата отказа</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td><Checkbox :id="'refused_' + item.id" v-bind:modelValue="true" :disabled="true"/></td>
                                                    <td>{{ item.actionRefuse.comment }}</td>
                                                    <td>{{ item.actionRefuse.createdBy }}</td>
                                                    <td>{{ $momentFormat(item.actionRefuse.created, "DD.MM.YYYY") }}</td>
                                                </tr>
                                                </tbody>
                                            </table>  
                                            </div>                      
                                        </template>
                                        <template v-if="item.organizations && item.organizations.length > 0">
                                        <div class="mb-4"><h4>Организации</h4></div>
                                        <div class="table-inner mb-4">
                                            <table class="table-custom">
                                                <thead>
                                                <tr>
                                                    <th >Название</th>
                                                    <th width="100px">ОГРН</th>
                                                    <th width="100px">ИНН</th>
                                                    <th width="100px">КПП</th>
                                                    <th width="215px">Адрес</th>
                                                    <th width="115px" >Заявление</th>
                                                    <th width="120px">Договор</th>
                                                    <th width="100px">Сотрудники</th>
                                                    <th width="120px">Найти на карте</th>
                                                    <!-- <th v-if="messenger?.isAvailable">Мессенджер</th> -->
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(org, idx) in item.organizations" :key="org.id" :class="{'text-green': org.isActive}">
                                                    <td class="col1">{{ org.name }}</td>
                                                    <td>{{ org.ogrn }}</td>
                                                    <td>{{ org.inn }}</td>
                                                    <td>{{ org.kpp }}</td>
                                                    <td>{{ org.address }}</td>
                                                    <td>
                                                        <div>
                                                            <file-download :file="org.statementFile"/>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <file-download :file="org.contractFile"/>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="org.employees && org.employees.length > 0" @click.stop="handlerEmplShow(org.employees)" class="text-center"><i
                                                            class="fas fa-eye"></i></div>
                                                    </td>
                                                    <td class="col5">
                                                        <div @click="findOnMap(org, item.kindActivityId, idx)" class="text-center"><i class="fas fa-map"></i></div>
                                                    </td>
                                                    <!-- <td v-if="messenger?.isAvailable" class="text-center">
                                                        <div class="messenger" @click="openMessenger(org.itemId)">
                                                        <i class="far fa-comments"></i>
                                                        <span :class="{'text-bold':org.unreadMessageCount > 0}">{{org.unreadMessageCount}}</span>
                                                        </div>
                                                    </td> -->
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        </template>

                                        <template v-if="item.isOrganizationChoose">
                                            <h4>Посещаемость</h4>
                                            <div class="table-inner mb-4">
                                            <table class="table-custom" v-if="item.visits && item.visits.length > 0">
                                                <thead>
                                                <tr>
                                                    <th width="130px">Дата занятия</th>
                                                    <th width="282px">Отметка о посещении</th>
                                                    <th>Вложение</th>
                                                    <th>Результаты посещений</th>
                                                    <th>Оценка</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(visit) in item.visits" v-bind:key="visit.id">
                                                    <td>{{ $momentFormat(visit.dateVisit, "DD.MM.YYYY") }}</td>
                                                    <td>{{ visit.markType }}</td>
                                                    <td>
                                                        <div>
                                                            <file-download :file="visit.file"/>
                                                        </div>
                                                    </td>
                                                    <td>{{ visit.result }}</td>
                                                    <td>{{ visit.mark }}</td>
                                                </tr>
                                                <tr v-if="item.isCompleted">
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Итоговый результат: <div>{{ item.resume }}</div></td>
                                                    <td></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                        </template>
                                    </div>
                                    </template>
                                </dropdown>
                            </div>
                        </div>
                </template>

                <section class="modals">
                        <modal-component v-if="mapShow">
                            <div>
                                <l-map v-if="mapShow" ref="myMap" style="height:50vh"
                                    :zoom="10"
                                    :center="mapCurrentCenter">
                                    <l-tile-layer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    ></l-tile-layer>
                                    <template v-for="el in organizationList" :key="el.id">
                                        <l-marker v-if="el.lat && el.lng"
                                                :lat-lng="el" :icon="getMarkerIcon(el.kindActivityId, el.addressId)"
                                        >
                                            <l-popup>
                                                <div>{{ el.name }}</div>
                                                <div>{{ el.address }}</div>
                                                <div class="link pt-2" v-on:click="setAddress(el)" v-if="!isReadonly">Выбрать</div>
                                            </l-popup>
                                        </l-marker>
                                    </template>

                                </l-map>
                                <div class="mt-1">
                                    <div class="float-right">
                                        <button type="button" class="btn btn-default" v-on:click="mapShow=false">Закрыть карту</button>
                                    </div>
                                </div>
                            </div>
                        </modal-component>
                        <modal-component v-show="emplShow" title="Сотрудники" @close="emplShow = false">
                            <table v-if="employees.length" class="table-custom">
                                <thead>
                                <tr>
                                    <th>Фамилия</th>
                                    <th>Имя</th>
                                    <th>Отчество</th>
                                    <th>Должность</th>
                                    <th>Телефон</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(empl, idx) in employees" :key="idx">
                                    <td>{{ empl.surname }}</td>
                                    <td>{{ empl.name }}</td>
                                    <td>{{ empl.patronymic }}</td>
                                    <td>{{ empl.position }}</td>
                                    <td>{{ empl.phone }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-else>Сотрудников нет</div>
                        </modal-component>
                        <modal-component v-if="modals.show" title="Карточка услуги" @close="modals.show = false">
                            <imar-service-card :card-id="modals.id" :journal-id="journalId" :is-readonly="modals.isReadonly"
                                            @close="modals.show = false" @save="modals.show = false;loadPage();"/>
                        </modal-component>
                        <modal-component v-if="visitModal.show" title="Карточка услуги" @close="visitModal.show = false" size-class="modal-xs">
                            <imar-visit-card :card-id="visitModal.id" :journal-imar-id="visitModal.journalImarId"
                                            @close="visitModal.show = false" @save="visitModal.show = false;loadPage();"/>
                        </modal-component>
                        <modal-component v-if="messenger.show" title="Мессенджер" class="modal-content--card"
                                        @close="messenger.show = false">
                            <MessengerForm :filter="messenger.filter"></MessengerForm>
                        </modal-component>
                    </section>

            </div>
        </div>
        <div>
            <div class="float-right d-flex align-items-center mt-4">
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>

  import Dropdown from "@/modules/journal/components/Dropdown";
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import Api from "../api/imar";
  import FileDownload from "../../../common/components/FileDownload";
  import { LMap, LMarker, LTileLayer,  } from "@vue-leaflet/vue-leaflet";
  import {latLng} from "leaflet";
  import ModalComponent from "@/common/ui/ModalComponent";
  import Utils from "../../../common/utils";
  import MessengerForm from "../../messenger/components/MessengerForm";
import ImarServiceCard from '../views/ImarServiceCard.vue';
import ImarVisitCard from '../views/ImarVisitCard.vue';
  import moment from 'moment'

  export default {
    name: "ImarModalCard",
    components: {FileDownload, ButtonComponent, Dropdown, ModalComponent,
      LMap,
      LMarker,
       LTileLayer,
       MessengerForm, ImarServiceCard, ImarVisitCard
    },
    props: {
      routeId: {
        type: Number
      },
      journalId: {
        type: Number
      }
    },
    data() {
      return {
        isLoading: true,
        haveCurrent: true,
        now: moment().format("YYYY-MM-DD") + "T00:00:00",
        items: [],
        organizationList: [],
        mapCurrentCenter: latLng(56.30, 44.01),
            mapIndex: null,
            mapAddressId: null,
            employees: [],
            emplShow: false,
            mapShow: false,
            modals: {
                show: false,
                id: null,
                isReadonly: false
            },
            visitModal: {
                show: false,
                id: null,
                journalImarId: null
            },
            messenger: {
              isAvailable: false,
              filter: {
                dialogType: null,
                patientId: null,
                journalImarOrganizationId: null
              },
              show: false
            }
      };
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        // Api.search({journalId: this.journalId, journalRouteId: this.routeId, activeOnly: true})
        //   .then((response) => {
        //     this.items = response.data;
        //     //console.log(this.items, "--- loadCard");
        //   });
        Api.search({journalId: this.journalId, journalRouteId: this.routeId/*, activeOnly: true*/})
          .then((response) => {
            let res = response.data.filter(x => x.isConfirmed);
            this.haveCurrent = res.some(x => x.dateEnd >= this.now)
            this.items = this.haveCurrent 
                ? res.filter(x => x.dateEnd >= this.now) 
                : res;
            //this.items = res;
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      close() {
        this.$emit('close');
      },
       getMarkerIcon(kindActivityId, isTemp) {
            //console.log(Utils.getMarkerIcon(kindActivityId, isTemp));
            return Utils.getMarkerIcon(kindActivityId, isTemp);
        },
        setAddress(el) {
            var orgItem = this.item.journalImarOrganizations[this.mapIndex];
            if (orgItem.organizationId != el.id) {
                orgItem.organizationId = el.id;
                this.changeOrganization(orgItem);
            }

            orgItem.addressId = el.addressId;
            this.mapShow = false;
            this.mapIndex = null;
        },
        findOnMap(el, kindActivityId, index) {
            el.kindActivityId = kindActivityId;
            this.organizationList = [el]
            this.mapShow = true;
            this.mapIndex = index;
            console.log(el);
            if(el.lat && el.lng) 
                this.mapCurrentCenter = latLng(el.lat, el.lng);
        },
        viewCard(id) {
            this.modals.id = id;
            this.modals.show = true;
            this.modals.isReadonly = true;
        },
        handlerEmplShow(el) {
            this.employees = el
            this.emplShow = true
        },
        openMessenger(id) {
            this.messenger.filter = {dialogType: 3, patientId: null, journalImarOrganizationId: id};
            this.messenger.show = true;
        },
    },
    computed: {
        itemsFilter() {
            if(!this.items)
                return [];
            var res = this.items;
            var resReduced = res.reduce((grouped, item) =>{
                const key = item['journalRouteName']
                if (!grouped[key]) {
                    grouped[key] = [];
                }
                // Add object to list for given key's value
                grouped[key].push(item);
                return grouped;                
            }, {})
            return resReduced;
        },
    },
  }
</script>

<style lang="scss" scoped>
    .scrollable-content {
        overflow-y: auto;
        max-height: calc(100vh - 250px);
    }
    .pmpk-view {
        max-width: 98%;
    }
</style>